import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const CancelSubscriptionAtPeriodEndMutation = graphql.persisted(
  "CancelSubscriptionAtPeriodEnd",
  graphql(`
    mutation CancelSubscriptionAtPeriodEnd($input: CancelSubscriptionAtPeriodEndInput!) {
      cancelSubscriptionAtPeriodEnd(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const CancelSubscriptionImmediatelyMutation = graphql.persisted(
  "CancelSubscriptionImmediately",
  graphql(`
    mutation CancelSubscriptionImmediately($input: CancelSubscriptionImmediatelyInput!) {
      cancelSubscriptionImmediately(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const ResumeSubscriptionMutation = graphql.persisted(
  "ResumeSubscription",
  graphql(`
    mutation ResumeSubscription($input: ResumeSubscriptionInput!) {
      resumeSubscription(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const ChangeSubscriptionNextCycleAmountMutation = graphql.persisted(
  "ChangeSubscriptionNextCycleAmount",
  graphql(`
    mutation ChangeSubscriptionNextCycleAmount($input: ChangeSubscriptionNextCycleAmountInput!) {
      changeSubscriptionNextCycleAmount(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const ReconcileSubscriptionDatesMutation = graphql.persisted(
  "ReconcileSubscriptionDates",
  graphql(`
    mutation ReconcileSubscriptionDates($input: ReconcileSubscriptionDatesInput!) {
      reconcileSubscriptionDates(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const MoveSubscriptionBillingDateMutation = graphql.persisted(
  "MoveSubscriptionBillingDate",
  graphql(`
    mutation MoveSubscriptionBillingDate($input: MoveSubscriptionBillingDateInput!) {
      moveSubscriptionBillingDate(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const ConvertSubscriptionToInvoicesMutation = graphql.persisted(
  "ConvertSubscriptionToInvoices",
  graphql(`
    mutation ConvertSubscriptionToInvoices($input: ConvertSubscriptionToInvoicesInput!) {
      convertSubscriptionToInvoices(input: $input) {
        success
        userErrors { message path }
        report {
          dryRun
          stripeStatus
          periodEndOn
          cancelAtOn
          pushedCount
          reconciledCount
          warnings
          invoices { invoiceId dueDate amountCents feeCents memo action }
        }
      }
    }
  `)
);

const CreateOneOffInvoiceMutation = graphql.persisted(
  "CreateOneOffInvoice",
  graphql(`
    mutation CreateOneOffInvoice($input: CreateOneOffInvoiceInput!) {
      createOneOffInvoice(input: $input) {
        success
        invoiceId
        userErrors { message path }
      }
    }
  `)
);

const CreatePaymentMethodUpdateLinkMutation = graphql.persisted(
  "CreatePaymentMethodUpdateLink",
  graphql(`
    mutation CreatePaymentMethodUpdateLink($input: CreatePaymentMethodUpdateLinkInput!) {
      createPaymentMethodUpdateLink(input: $input) {
        success
        url
        userErrors { message path }
      }
    }
  `)
);

export {
  CancelSubscriptionAtPeriodEndMutation,
  CancelSubscriptionImmediatelyMutation,
  ResumeSubscriptionMutation,
  ChangeSubscriptionNextCycleAmountMutation,
  ReconcileSubscriptionDatesMutation,
  MoveSubscriptionBillingDateMutation,
  ConvertSubscriptionToInvoicesMutation,
  CreateOneOffInvoiceMutation,
  CreatePaymentMethodUpdateLinkMutation,
};

export function useCancelSubscriptionAtPeriodEnd() {
  return useMutation(CancelSubscriptionAtPeriodEndMutation);
}

export function useCancelSubscriptionImmediately() {
  return useMutation(CancelSubscriptionImmediatelyMutation);
}

export function useResumeSubscription() {
  return useMutation(ResumeSubscriptionMutation);
}

export function useChangeSubscriptionNextCycleAmount() {
  return useMutation(ChangeSubscriptionNextCycleAmountMutation);
}

export function useReconcileSubscriptionDates() {
  return useMutation(ReconcileSubscriptionDatesMutation);
}

export function useMoveSubscriptionBillingDate() {
  return useMutation(MoveSubscriptionBillingDateMutation);
}

export function useConvertSubscriptionToInvoices() {
  return useMutation(ConvertSubscriptionToInvoicesMutation);
}

export function useCreateOneOffInvoice() {
  return useMutation(CreateOneOffInvoiceMutation);
}

export function useCreatePaymentMethodUpdateLink() {
  return useMutation(CreatePaymentMethodUpdateLinkMutation);
}
